// utils
import {
  characterWalk
} from '@/assets/js/utils/characterWalk'
import {
  characterSpeech
} from '@/assets/js/utils/characterSpeech'
import {
  createBlinkAnimation
} from '@/assets/js/utils/createBlinkAnimation'
import {
  updateText
} from '@/assets/js/utils/updateText'

// character animations
import {
  reeceAnimations
} from '@/assets/js/characters/reeceAnimations'
import {
  haileyAnimations
} from '@/assets/js/characters/haileyAnimations'
import {
  devynAnimations
} from '@/assets/js/characters/devynAnimations'
import {
  riaAnimations
} from '@/assets/js/characters/riaAnimations'
import {
  ayeAnimations
} from '@/assets/js/characters/ayeAnimations'

import {
  skylarAnimations
} from './skylarAnimations'
import {
  dylanAnimations
} from './dylanAnimations'
import {
  joeAnimations
} from './joeAnimations'

const reece = reeceAnimations()
const hailey = haileyAnimations()
const devyn = devynAnimations()
const ria = riaAnimations()
const aye = ayeAnimations()
const skylar = skylarAnimations()
const dylan = dylanAnimations()
const joe = joeAnimations()

const sandbox = (ctx) => {

  // init blink animations
  // createBlinkAnimation("devyn")

  devyn.rotate({flipped: true}).deskHands()

  aye.rotate({flipped: true}).deskHands()



  // dylan
  //   .handShake({
  //     complete() {
  //       dylan.lowerRightArm({
  //         delay: 450
  //       })
  //     }
  //   })

  // skylar.walk({
  //   left: ["100%", "-25%"]
  // }).wave({
  //   complete() {
  //     skylar.lowerRightArm()
  //   }
  // })

  aye.rotate({
    flipped: true,
    complete() {
      aye.deskHands({
        delay: 250,
        complete() {
          aye
            .headRotate({
              flipped: true
            })
            .lowerRightArm({
              delay: 750
            })
            .lowerLeftArm({
              complete() {
                aye.raiseLeftArm({
                  half: true,
                  delay: 250
                })
              }
            })

        }
      })
    }
  })

  // devyn.rotate({
  //   flipped: false,
  //   complete() {
  //     devyn.deskHands({
  //       delay: 250,
  //       complete() {
  //         devyn
  //           .raiseRightArm({
  //             quarter: true
  //           })
  //           .headRotate()
  //       }
  //     }).headRotate({
  //       flipped: true
  //     })
  //   }
  // })

}

export {
  sandbox
}



// WEBPACK FOOTER //
// ./src/components/module_6/js/sandbox.js